import apiFetch from '../apiFetch'

export default function (token, documentTypeId, entityId, fromTask = false) {
  return apiFetch({ endPoint: `document?documentTypeId=${documentTypeId}&id=${entityId || 'null'}&fromTask=${fromTask}`, method: 'GET', token: token })
}
